import { Link } from 'gatsby';
import * as React from 'react';
import { CardItem } from '../cardItem/CardItem';
import { Container } from '../container/Container';
import * as styles from './CardItemSection.module.scss';
import { IGatsbyImageData } from 'gatsby-plugin-image';

type Post = {
  id: string;
  imgUrl?: string | null;
  title: string;
  date?: string;
  tag?: string;
  link?: string;
  tags?: string[];
  gatsbyImage?: IGatsbyImageData;
};

export const CardItemSection = ({
  title,
  posts,
  allToText,
  allToLink,
  className,
  isMobileLinkDisplayed = true,
  isDesktopLinkDisplayed = true,
}: {
  posts: Post[];
  allToText: string;
  allToLink: string;
  className?: string;
  title?: string;
  isMobileLinkDisplayed?: boolean;
  isDesktopLinkDisplayed?: boolean;
}) => (
  <Container className={className}>
    <div className={styles.cardItemSection__header}>
      <p className={styles.cardItemSection__title}>{title}</p>
      {isDesktopLinkDisplayed ? (
        <Link to={allToLink} className={styles.cardItemSection__desktopLink}>
          {allToText}
        </Link>
      ) : null}
    </div>
    {posts.map((post) => (
      <Link key={post.id} to={post.link || ''} className={styles.cardItemSection__link}>
        <CardItem
          key={post.id}
          imgUrl={post.imgUrl}
          gatsbyImage={post.gatsbyImage}
          title={post.title}
          subtitle={post.date}
          tags={post.tags || (post.tag && [post.tag]) || []}
        />
      </Link>
    ))}
    {isMobileLinkDisplayed ? (
      <Link to={allToLink} className={styles.cardItemSection__mobileLink}>
        {allToText}
      </Link>
    ) : null}
  </Container>
);
